import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTrainingPageData = createAsyncThunk(
  'profileTraining/fetchPageData',
  async ({ userEmail }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/Training/pageData`, {
        signal,
        params: { userEmail },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileTraining/fetchPageData failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch training page data');
    }
  }
);

const slice = createSlice({
  name: 'profileTraining',
  initialState: { pageData: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainingPageData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainingPageData.fulfilled, (state, action) => {
        state.loading = false;
        state.pageData = action.payload ?? null;
      })
      .addCase(fetchTrainingPageData.rejected, (state, action) => {
        state.loading = false;
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || 'Failed to fetch training page data';
      });
  },
});

export default slice.reducer;


